// extracted by mini-css-extract-plugin
export default {"collapseWrapper":"index_collapseWrapper__lFGQ0","rotateCollapse":"index_rotateCollapse__YCDTh"};